import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import TextfieldFloatingText from '../../../portal/textfieldFloatingText';
import styles from '../style.scss';
import PortalTextBox from '../../../portal/portalTextBox';
import { TooltipTextWrapper } from '../../../common/tooltipTextWrapper';

@inject('translationsStore', 'samlStore') @observer
export default class MappingAttributesContainer extends Component {

    samlStore = this.props.samlStore;

    onChangeRoleMappingAttribute = e => this.samlStore.setRoleMappingAttribute(e.target.value);
    onChangeTeamMappingAttribute = e => this.samlStore.setTeamMappingAttribute(e.target.value);    
    handleTeamMappingOnBlur = e => this.samlStore.validator.validateTeamMappingAttribute(e.target.value);

    render() {

        const t = this.props.translationsStore.translate;
        const roleTooltip = `${t('SAML_ROLE_ATTRIBUTE')} ${t('IDP_ROLE_TEAM_MAPPING_TOOLTIP')}`.replace('{EnableIdpMapping}', t('ENABLE_IDP_MAPPING'));
        const teamTooltip = `${t('SAML_TEAM_ATTRIBUTE')} ${t('IDP_ROLE_TEAM_MAPPING_TOOLTIP')}`.replace('{EnableIdpMapping}', t('ENABLE_IDP_MAPPING'));
        
        return !this.samlStore.isMappingEnabled ? null :               
 
            <div className={styles.samlFormRow}>

                <PortalTextBox
                    dataCy={'saml-role-mapping-attribute'}
                    hintText={t('SAML_ROLE_ATTRIBUTE')}
                    floatingLabelText={<TextfieldFloatingText title={t('SAML_ROLE_ATTRIBUTE')} />}
                    width='47%'
                    disabled={!this.samlStore.isMappingEnabled}
                    onChange={this.onChangeRoleMappingAttribute}
                    value={this.samlStore.roleMappingAttribute || ''}
                    helpTooltipText={<TooltipTextWrapper text={roleTooltip}/>}
                />

                <PortalTextBox
                    dataCy={'saml-team-mapping-attribute'}
                    hintText={t('SAML_TEAM_ATTRIBUTE')}
                    floatingLabelText={<TextfieldFloatingText title={t('SAML_TEAM_ATTRIBUTE')} required={true} />}
                    width='47%'
                    disabled={!this.samlStore.isMappingEnabled}
                    onChange={this.onChangeTeamMappingAttribute}
                    onBlur={this.handleTeamMappingOnBlur}
                    errorText={this.samlStore.validator.teamMappingAttributeValidationMessage}
                    value={this.samlStore.teamMappingAttribute || ''}
                    helpTooltipText={<TooltipTextWrapper text={teamTooltip}/>}
                />    
            </div>;
    }
}


// WEBPACK FOOTER //
// ./src/components/saml/addEditForm/userAuthorizationManagement/mappingAttributesContainer.jsx